import { Link } from 'react-router-dom';
import { videos } from '@/mocks/videos';
import { categories } from '@/mocks/videos';

export default function StatsSection() {
  const stats = [
    { value: '2000万+', label: '月活跃用户', icon: 'ri-user-line' },
    { value: '10万+', label: '视频资源', icon: 'ri-film-line' },
    { value: '4', label: '合作平台', icon: 'ri-building-line' },
    { value: '99.9%', label: '播放流畅率', icon: 'ri-speed-up-line' },
  ];

  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-primary-500">
      <div className="max-w-[1200px] mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-background-50 mb-3">
            桔子视频 · 数据说话
          </h2>
          <p className="text-sm md:text-base text-background-200">
            用实力证明，我们是最好的视频聚合平台
          </p>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
          {stats.map((stat, index) => (
            <div
              key={index}
              className="text-center p-6 rounded-2xl bg-background-50/10 backdrop-blur-sm"
            >
              <div className="w-10 h-10 rounded-full bg-background-50/20 flex items-center justify-center mx-auto mb-3">
                <i className={`${stat.icon} text-background-50 text-lg`}></i>
              </div>
              <div className="font-heading text-2xl md:text-3xl font-bold text-background-50 mb-1">
                {stat.value}
              </div>
              <div className="text-sm text-background-200">
                {stat.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}